import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SecurityService } from '../services/security.service';

@Injectable({
  providedIn: 'root',
})
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private jwtHelper: JwtHelperService, private securityService: SecurityService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userInfos = this.securityService.getUser();
    const companyInfo = userInfos?.companies.find(company => company.companyId == userInfos.companyId);

    if (req.withCredentials) {
      req = req.clone({
        setHeaders: {
          Authorization: 'Bearer ' + this.jwtHelper.tokenGetter(),
          Companyid: companyInfo?.companyGuid ?? null
        },
        withCredentials: false,
      });
    }
    return next.handle(req);
  }
}
